// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const JobStatus = {
  Scheduled: "scheduled",
  Pending: "pending",
  Running: "running",
  Completed: "completed",
  Failed: "failed",
  Cancelled: "cancelled",
  Crashed: "crashed",
  Paused: "paused",
  Cancelling: "cancelling",
} as const;
export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus];

export function instanceOfJobStatus(value: any): boolean {
  for (const key in JobStatus) {
    if (Object.prototype.hasOwnProperty.call(JobStatus, key)) {
      if (JobStatus[key as keyof typeof JobStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function JobStatusFromJSON(json: any): JobStatus {
  return JobStatusFromJSONTyped(json, false);
}

export function JobStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobStatus {
  return json as JobStatus;
}

export function JobStatusToJSON(value?: JobStatus | null): any {
  return value as any;
}

export function JobStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): JobStatus {
  return value as JobStatus;
}
